import bridge from '@vkontakte/vk-bridge';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import store from './store';

import '@vkontakte/vkui/dist/vkui.css';

import './index.css';

// Init VK Mini App
bridge.send('VKWebAppInit', {});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
